import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StatistikProduktivitetMedarbejder } from '../../models/StatistikProduktivitetMedarbejder';
import { EmployeeTimeLogViewModelList } from '../../models/EmployeeTimeLogViewModel';
import { Observable } from 'rxjs';
import { StatistikService } from '../../statistik.service';

@Component({
    selector: 'app-statistik-produktivitet-employee-time-log-modal-ui',
    templateUrl: './statistik-produktivitet-employee-time-log-modal.component.html',
    styleUrls: ['./statistik-produktivitet-employee-time-log-modal.component.scss'],
    standalone: false
})
export class StatistikProduktivitetEmployeeTimeLogModal implements OnInit {
    medarbejder: StatistikProduktivitetMedarbejder;
    selectedPeriod: { fra: string, til: string };
    selectedGruppe: number;

    EmployeeTimeLogList$: Observable<EmployeeTimeLogViewModelList[]>;

    constructor(private activeModal: NgbActiveModal,
                private statistikService: StatistikService) {
    }

    ngOnInit(): void {
        this.EmployeeTimeLogList$ = this.statistikService
            .getEmployeeTimeLogView(this.medarbejder.medID, this.selectedGruppe, this.selectedPeriod);
    }

    onDismiss() {
        this.activeModal.dismiss();
    }

    getTotal(viewModel: EmployeeTimeLogViewModelList) {
        return viewModel.employeeTimeLogViewModels.reduce((acc, x) => acc + x.timer, 0);
    }

    getGrandTotal(employeeTimeLogViewModelLists: EmployeeTimeLogViewModelList[] | null) {
        return employeeTimeLogViewModelLists?.reduce((acc, x) => acc + this.getTotal(x), 0);
    }
}







